
import { MLCourse } from './types';
import { ML_FUNDAMENTALS_COURSE } from './fundamentals';
import { ML_INTERMEDIATE_COURSE } from './intermediate';
import { ML_ADVANCED_COURSE } from './advanced';

export const ML_COURSES: MLCourse[] = [
  ML_FUNDAMENTALS_COURSE,
  ML_INTERMEDIATE_COURSE,
  ML_ADVANCED_COURSE
];

// Export individual courses for direct access
export { 
  ML_FUNDAMENTALS_COURSE,
  ML_INTERMEDIATE_COURSE,
  ML_ADVANCED_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const ML_COURSE_METADATA = {
  totalCourses: ML_COURSES.length,
  totalDuration: '45-55 hours',
  levels: ['fundamentals', 'intermediate', 'advanced'],
  skillsPath: [
    'ML Theory & Fundamentals',
    'Data Preprocessing & Feature Engineering',
    'Supervised & Unsupervised Learning',
    'Deep Learning & Neural Networks',
    'Advanced Algorithms & Ensembles',
    'Natural Language Processing',
    'Computer Vision',
    'MLOps & Production Deployment',
    'Model Monitoring & Maintenance',
    'Ethical AI & Interpretability'
  ]
};
